export const generateCloudStorageUrl = (bucket, object) => `https://storage.googleapis.com/${bucket}/${object}`
